import React, { Component } from 'react';
import ComboBox from '../combo-box'
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import SearchIcon from 'material-ui-icons/Search'
import Portal from 'material-ui/Portal'
import Input from 'material-ui/Input';
import SaveIcon from 'material-ui-icons/Save';
import CloseIcon from 'material-ui-icons/Close';
import Typography from 'material-ui/Typography';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import AddIcon from 'material-ui-icons/Add';
import DownloadIcon from 'material-ui-icons/FileDownload';
import RemoveFPIcon from 'material-ui-icons/PortableWifiOff';

import List, { ListItem, ListItemSecondaryAction, ListItemText } from 'material-ui/List';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import Paper from 'material-ui/Paper';


import EditIcon from 'material-ui-icons/ModeEdit';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/DeleteForever';
import UploadIcon from 'material-ui-icons/FileUpload';
import DetailsIcon from 'material-ui-icons/Details';

import SelectEmployeeForDevice from './SelectEmployeeForDevice';


import {ajaxPost} from '../ajax';
import IconButton from 'material-ui/IconButton/IconButton';
import DeleteDeviceDialog from './DeleteDeviceDialog';
import SelectDeviceDialog from './SelectDeviceDialog';


const styles = theme => ({
    search: {
      width: 200,
      //color:"white",
      height:50,
    },
    input:
    {
        position:"absolute",
        marginTop:15,
    },
    title:
    {
        // color:"#2574bb",
        // flex:1,
        // marginLeft:-10,
        // marginTop:10,
    },
    button: {
        '&:hover': {
          backgroundColor: green[700],
        },
      },
      fabProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -25,
        marginLeft: -25,
          },
      wrapper: {
        //margin: theme.spacing.unit,
        position: 'relative',
      },

      dialog:
      {
          margin:"20px 20px 40px 20px"
      },
      table: {
        minWidth: 700,
        marginTop:20,
      },
      main:
{
  margin:10
},
toolBarImage: {
    width: "20px",
    height: "20px",
},
tableContent:{
    "font-weight":"500",
},

    });

  
class SearchDevice extends Component {

    state = 
    {
        title:'',
        search:'',
        selected:null,
        listDevices:[],
        mode:"search",
        saving:false,
        dialog:false,
        dialogContent:null,
        dialogTitle:'',
        deleteDialog:false,
        uploadDialog:false,
        removeDialog:false,
        downloadDialog:false,
        getInfoDialog:false,
    }

    componentDidMount()
    {
        if( this.props.firstLoad )
            this.doSearch("");
        else
            this.setState({listDevices:this.props.searchState.listDevices});
    }


    onSearch = (event) =>
    {
        var str = event.target.value;
        this.setState({search:str})
        this.doSearch(str);
    }

    onClickSearch = (event) =>
    {
        this.doSearch(this.state.search);
    }

    doSearch = (str) =>
    {
        ajaxPost({
                url:'/DeviceAPI/ListDevices',
                data:{
                    Search:str,
                    OfflineOnly:false,
                    ActiveOnly:false,
                },
                startIndex:0,
                maxData:50,
                onSuccess: data =>
                {
                    this.setState({listDevices:data});
                },
                finally:()=>{}
            }
        )
    }

    onSelectDevice(dev,event)
    {
        if( this.props.onSelectDevice != null )
            this.props.onSelectDevice(dev,this.state);
            
        this.setState({selected:dev})
    }


    onDelete = ()=>
    {
        this.setState({deleteDialog:true});
    }

    onUploadDialogClose = () =>
    {
        this.setState({uploadDialog:false});
    }

    onDownloadDialogClose = (success) =>
    {
        this.setState({downloadDialog:false});
    }

    onRemoveDialogClose = (success) =>
    {
        this.setState({removeDialog:false});
    }

    onActionDownload = (empIDs)=>
    {
        ajaxPost({
            url:'/DeviceCommandAPI/SendDownloadUserDeviceCommand',
            data:{
                DeviceID:this.state.selected.DeviceID,
                EmployeeIDs:empIDs,
            },
            onSuccess: data =>
            {
                global.updateNotifications();
                this.setState({downloadDialog:false});
            },
            finally:()=>{}
        });
    }

    onUploadAction = (empIDs) =>
    {
        this.setState({uploadDialog:false});
        ajaxPost({
            url:'/DeviceCommandAPI/SendUploadUserDeviceCommand',
            data:{
                DeviceIDs:[this.state.selected.DeviceID],
                EmployeeIDs:empIDs,
                Privilege:"USER",
            },
            onSuccess: data =>
            {
                global.updateNotifications();
            },
            finally:()=>{}
        });
    }

    onActionRemove = (empIDs)=>
    {
        ajaxPost({
            url:'/DeviceCommandAPI/SendDeleteUserDeviceCommand',
            data:{
                DeviceIDs:[this.state.selected.DeviceID],
                EmployeeIDs:empIDs,
            },
            onSuccess: data =>
            {
                global.updateNotifications();
                this.setState({removeDialog:false});
            },
            finally:()=>{}
        });
    }

    onUpload = ()=>
    {
        this.setState({uploadDialog:true});
    }

    onDownload = ()=>
    {
        this.setState({downloadDialog:true});
    }

    onRemove = () =>
    {
        this.setState({removeDialog:true});
    }



    onDeleteDialogClose = (success) =>
    {
        this.setState({deleteDialog:false});
        if( success )
        {
            this.setState({listDevices:this.state.listDevices.filter(item=>item != this.state.selected)})
            this.setState({selected:null});
        }

    }

    onDownloadInfo = () =>
    {
        this.setState({getInfoDialog:true});
    }

    onGetInfoClose = () =>
    {
        this.setState({getInfoDialog:false});
    }

    onActionGetInfo = (device) =>
    {
        this.setState({getInfoDialog:false});
        ajaxPost({
            url:'/DeviceCommandAPI/GetInfoCommand',
            data:{
                DeviceIDs:device == null ? [] : [device.DeviceID],
            },
            onSuccess: data =>
            {
                global.updateNotifications();
            },
            finally:()=>{}
        });
    }

    render()
    {
        var {classes} = this.props;

        return (
        <div className={classes.main}>
            <Portal container={this.props.toolbar}>
            <Portal container={global.lblHeader}>
            <Typography variant="title" color="inherit" className={classes.title}>
            <span>
            Device Module
            </span>
            </Typography>
            </Portal>
            <Input onChange={this.onSearch} className={classes.search} value={this.state.search} />
            <div className={classes.wrapper}>
            <IconButton color="inherit" className={classes.button} onClick={this.onClickSearch.bind(this)}>
            <img src="search.png" className={classes.toolBarImage} />
                           
            </IconButton>
            </div>
            <div className={classes.wrapper}>
            <Tooltip id="tooltip-enroll"  title="Add" >
            <IconButton color="inherit" className={classes.button} onClick={this.props.onAdd.bind(this,this.state)}>
            <img src="add.png" className={classes.toolBarImage} />
                               
            </IconButton>
            </Tooltip>
            <Tooltip id="tooltip-enroll"  title="Edit">
            <IconButton disabled={this.state.selected==null}  color="inherit" className={classes.button} onClick={this.props.onEdit.bind(this,this.state)}>
            { this.state.selected==null ? <img src="edit-disable.png" className={classes.toolBarImage}/> :  <img src="edit.png" className={classes.toolBarImage}/> }
            
            </IconButton>
            </Tooltip>

            <Tooltip id="tooltip-delete"  title="Delete">
            <IconButton disabled={this.state.selected==null} color="inherit" className={classes.button} onClick={this.onDelete.bind(this)}>
            { this.state.selected==null ? <img src="delete-disable.png" className={classes.toolBarImage}/> :  <img src="delete.png" className={classes.toolBarImage}/> }
                             
            </IconButton>
            </Tooltip>
            <Tooltip id="tooltip-download"  title="Download Employee Record from Device">
            <IconButton disabled={this.state.selected==null} color="inherit" className={classes.button} onClick={this.onDownload.bind(this)}>
            { this.state.selected==null ? <img src="download-disable.png" className={classes.toolBarImage}/> :  <img src="download.png" className={classes.toolBarImage}/> }
                        
            </IconButton>
            </Tooltip>
            
            <Tooltip id="tooltip-upload"  title="Upload Employee Record to Device">
            <IconButton disabled={this.state.selected==null} color="inherit" className={classes.button} onClick={this.onUpload.bind(this)}>
             { this.state.selected==null ? <img src="upload-disable.png" className={classes.toolBarImage}/> :  <img src="upload.png" className={classes.toolBarImage}/> }
                         
            </IconButton>
            </Tooltip>
            <Tooltip id="tooltip-delete-fp"  title="Remove Employee Record from Device">
            <IconButton disabled={this.state.selected==null}  color="contrast" className={classes.button} onClick={this.onRemove.bind(this)}>
                <RemoveFPIcon />
            </IconButton>
            </Tooltip>
            <Tooltip id="tooltip-info"  title="Download device information">
            <IconButton color="inherit" color="contrast"  className={classes.button} onClick={this.onDownloadInfo.bind(this)}>
                <DetailsIcon />
            </IconButton>
            </Tooltip>
            </div> 
            </Portal>
            <Paper style={{ "background": "rgba(255,255,255,0.5)" }} >
                <Table className={classes.table}>
                <Portal container={global.tblHeader}>
                <TableHead>
                <TableRow>
                    <TableCell style={{ "minWidth":"150px","maxWidth": "150px"}}>Name</TableCell>
                    <TableCell style={{ "minWidth":"250px","maxWidth": "250px"}}>Serial</TableCell>
                    <TableCell style={{ "minWidth":"200px","maxWidth": "200px"}}>IPAddress</TableCell>
                    <TableCell style={{ "minWidth":"110px","maxWidth": "110px"}}>Status</TableCell>
                    <TableCell style={{ "minWidth":"100px","maxWidth": "100px"}}>FP Cnt</TableCell>
                    <TableCell style={{ "minWidth":"100px","maxWidth": "100px"}}>User Cnt</TableCell>
                    <TableCell style={{ "minWidth":"100px","maxWidth": "100px"}}>Active</TableCell>
                    <TableCell >&nbsp;</TableCell>
                </TableRow>
                </TableHead>
                </Portal>
                <TableBody className={classes.tableContent}>
                {this.state.listDevices.map(n => {
                    return (
                    <TableRow tag={n} selected={n===this.state.selected}  onClick={this.onSelectDevice.bind(this,n)}>
                        <TableCell style={{ "minWidth":"150px","maxWidth": "150px"}}>{n.DeviceName}</TableCell>
                        <TableCell style={{ "minWidth":"250px","maxWidth": "250px"}}>{n.SerialNumber}</TableCell>
                        <TableCell style={{ "minWidth":"220px","maxWidth": "220px"}}>{n.IPAddress}</TableCell>
                        <TableCell style={{ "minWidth":"130px","maxWidth": "130px", "color":n.ConnectionStatus != "OFFLINE" ? "green" : "red"}}>{n.ConnectionStatus}</TableCell>
                        <TableCell style={{ "minWidth":"100px","maxWidth": "100px"}}>{n.DeviceInformation != null && n.DeviceInformation.FPCount}</TableCell>
                        <TableCell style={{ "minWidth":"100px","maxWidth": "100px"}}>{n.DeviceInformation != null && n.DeviceInformation.UserCount}</TableCell>
                        <TableCell style={{ "minWidth":"100px","maxWidth": "100px", "color":n.Status != 'DISABLED' ? "green" : "blue" }}>{n.Status != 'DISABLED' ? 'YES' : 'NO'}</TableCell>
                        <TableCell>&nbsp;</TableCell>
                    </TableRow>
                    );
                })}
                </TableBody>
            </Table>
            </Paper>
            {this.state.deleteDialog && 
            <DeleteDeviceDialog 
             open={true}
             device={this.state.selected} 
             onClose={this.onDeleteDialogClose.bind(this)} 
             />}

            {this.state.removeDialog && 
                <SelectEmployeeForDevice title="Remove Employee Record from Device" 
                action="remove" 
                onClose={this.onRemoveDialogClose.bind(this)} 
                onAction={this.onActionRemove}
                allowSelectAll={true} 
                caption="Select the employee you want the fingerprint to be removed"
                />}

            {this.state.downloadDialog && 
                <SelectEmployeeForDevice title="Download Employee Record from Device" 
                action="download" 
                onClose={this.onDownloadDialogClose.bind(this)} 
                onAction={this.onActionDownload}
                caption="Select the employee you want the fingerprint to be downloaded"
                allowSelectAll={true} 
                />}

            {this.state.uploadDialog && 
                <SelectEmployeeForDevice title="Upload Employee Record to Device" 
                action="upload" 
                onClose={this.onUploadDialogClose.bind(this)} 
                onAction={this.onUploadAction}
                allowSelectAll={true} 
                caption="Select the employees you want the fingerprint to be uploaded to"
                />}

            {this.state.getInfoDialog && 
                <SelectDeviceDialog title="Get device information" 
                action="sync" 
                onClose={this.onGetInfoClose.bind(this)} 
                onAction={this.onActionGetInfo}
                allowSelectAll={true} 
                caption="Select the device you want get its hardware information"
                />}
                
            
            </div>
        )
    }
}

export default withStyles(styles)(SearchDevice);



// WEBPACK FOOTER //
// ./src/admin/SearchDevice.js